import React, { useState, useEffect } from 'react';
import { Layout } from 'antd';
import { Sidebar } from '@src/components/Layout/Sidebar';
import { SidebarProvider } from '@src/components/Layout/SidebarContext';
import { Outlet } from 'react-router';

const { Content } = Layout;

export const MainLayout: React.FC = () => {
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);
  const [isMobile, setIsMobile] = useState(false);

  // Check if screen is mobile
  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth <= 768);
    };
    
    checkMobile();
    window.addEventListener('resize', checkMobile);
    return () => window.removeEventListener('resize', checkMobile);
  }, []);

  return (
    <SidebarProvider>
      <Layout style={{ height: '100vh', overflow: 'hidden' }}>
        <Sidebar collapsed={sidebarCollapsed} onCollapse={setSidebarCollapsed} />
        <Layout
          style={{
            height: '100vh',
            overflow: 'hidden',
          }}
        >
          <Content
            style={{
              margin: isMobile ? 0 : '20px',
              padding: 0,
              height: '100vh',
              background: '#f5f5f5',
              overflow: 'auto',
              overflowX: 'hidden',
              scrollBehavior: 'smooth',
              WebkitOverflowScrolling: 'touch',
              touchAction: 'pan-y',
            }}
          >
            <Outlet />
          </Content>
        </Layout>
      </Layout>
    </SidebarProvider>
  );
};
